import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import backgrounds from '../assets/background';

/**
 * Optimized selector - only extracts cover_image to minimize re-renders
 * @param {object} state - Redux state
 * @returns {string} Cover image key
 */
const selectCoverImage = (state) => 
  state.profile?.profile?.cover_image || 
  state.profile?.profile?.theme?.coverImage || 
  'foody';

/**
 * Custom hook to get dynamic background image based on store profile
 * Performance optimized with memoization and specific selector
 * @returns {string} Background image URL
 * 
 * Usage:
 * const backgroundImage = useBackgroundImage();
 */
const useBackgroundImage = () => {
  // Only subscribe to cover_image changes, not entire profile
  const coverImage = useSelector(selectCoverImage);
  
  // Memoize the background image lookup to avoid unnecessary recalculations
  const backgroundImage = useMemo(() => {
    if (coverImage === 'noBackground') {
      // Explicitly no background image
      return '';
    }
    return backgrounds[coverImage] || backgrounds.foody;
  }, [coverImage]);
  
  return backgroundImage;
};

export default useBackgroundImage;

